import React, { useEffect, useState } from "react";
import { RemainingEvidenceList } from "./RemainingEvidenceList";
import { ConfirmedEvidence } from "./ConfirmedEvidence";
import { RuledOutEvidence } from "./RuledOutEvidence";
import styled from "styled-components";
export function EvidenceManager({
  onEvidenceChanged,
  evidenceNeededForSuggestions,
  selectedEvidence,
  ruledOutEvidence,
  onRuledOutEvidenceClicked,
  showRuleOut,
}) {
  const [evidenceRound, setEvidenceRound] = useState(0);
  useEffect(() => {
    setEvidenceRound(selectedEvidence.length + 1);
  }, [selectedEvidence]);
  const onEvidencePicked = (newEvidence) => {
    const newEvidenceList = selectedEvidence;
    newEvidenceList.push(newEvidence);
    setEvidenceRound(newEvidenceList.length + 1);
    onEvidenceChanged(newEvidenceList);
  };
  const onRemoveEvidence = (evidenceToRemove) => {
    let newEvidenceList = selectedEvidence;
    newEvidenceList = newEvidenceList.filter(
      (evidence) => evidence !== evidenceToRemove
    );
    setEvidenceRound(newEvidenceList.length + 1);
    onEvidenceChanged(newEvidenceList);
  };
  return (
    <Panel>
      {selectedEvidence.length > 0 && (
        <ConfirmedEvidence
          selectedEvidence={selectedEvidence}
          onRemoveEvidence={onRemoveEvidence}
        />
      )}
      {evidenceRound <= 3 && (
        <RemainingEvidenceList
          ruledOutEvidence={ruledOutEvidence}
          evidenceNeededForSuggestions={evidenceNeededForSuggestions}
          selectedEvidence={selectedEvidence}
          onEvidencePicked={onEvidencePicked}
        />
      )}
      {showRuleOut && (
        <RuledOutEvidence
          ruledOutEvidence={ruledOutEvidence}
          onRuledOutEvidenceClicked={onRuledOutEvidenceClicked}
          selectedEvidence={selectedEvidence}
          evidenceNeededForSuggestions={evidenceNeededForSuggestions}
        />
      )}
    </Panel>
  );
}
const Panel = styled.div`
  width: 100%;
`;
export default EvidenceManager;
